import React, { useEffect, useState } from 'react';
import WhiteCard from '../../../../components/accountCards/WhiteCard';
import { CreateAccountTypeApi, GetAllAccountTypeApi } from '../../../../api/request/account';
import { useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from "react-router-dom";
import { Spin, Form, Select } from 'antd';
import toast from 'react-hot-toast';
import ModalComponent from '../../../../components/modals/ModalComponent.jsx';
import LoadableButton from '../../../../components/buttons/LoadableButton.jsx';
import Copy from '../../../../components/copy/Copy.jsx';
import ConfirmationModal from '../../../../components/modals/ConfirmationModal.jsx';

export default function AccountTypes() {

    const [form] = Form.useForm();
    const navigate = useNavigate();
    const { userDetails } = useSelector(state => state.user);
    const [searchParams] = useSearchParams();
    const [accountTypes, setAccountTypes] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedAccount, setSelectedAccount] = useState(false);
    const [createdDemoAccount, setCreatedDemoAccount] = useState(null);
    const [demoInitialValues, setDemoInitialValues] = useState({ depositAmount: null, leverage: null });
    const [isOpenDemoForm, setIsOpenDemoForm] = useState(false);
    const [isOpenDemoAccountSuccess, setIsOpenDemoAccountSuccess] = useState(false);
    const [isDemoFormLoading, setIsDemoFormLoading] = useState(false);
    const [isOpenLiveForm, setIsOpenLiveForm] = useState(false);
    const [isLiveFormLoading, setIsLiveFormLoading] = useState(false);
    const [depositOptions, setDepositOptions] = useState([{ value: 1000, label: '1000' }, { value: 3000, label: '3000' }, { value: 5000, label: '5000' }, { value: 50000, label: '50000' }, { value: 100000, label: '100000' }]);
   

    const getAcounts = async () => {
        try {
            setIsLoading(true);
            let params = {
                userId: userDetails.id,
                tradingAccountType: searchParams?.get('type') == 'live' ? 0 : 1
            }
            const { data } = await GetAllAccountTypeApi(params);
            if (data?.success) {
                setAccountTypes(data?.data);
            }
            setIsLoading(false);
        } catch (error) { }
    }

    useEffect(() => {
        getAcounts();
    }, []);

    const createAccount = (account) => {
        setSelectedAccount(account);
        if (searchParams?.get('type') == 'live') {
            setIsOpenLiveForm(true);
            return;
        }
        if (searchParams?.get('type') == 'demo') {
            setIsOpenDemoForm(true);
            return;
        }
    }

    const handleDemoAccount = async (values) => {
        try {
            setIsDemoFormLoading(true);
            let params = {
                balanceDeposit: values.depositAmount,
                // groupId: selectedAccount?.groupId,
                // groupName: selectedAccount?.groupName,
                tradingAccountType: 1,
                planId: selectedAccount?.planId,
                userId: userDetails?.id
            }
            const { data } = await CreateAccountTypeApi(params);
            if (data?.success) {
                setCreatedDemoAccount(data?.data);
                setIsDemoFormLoading(false);
                toast?.success(data?.message);
                setIsOpenDemoAccountSuccess(true);
            }
        } catch (error) {
            if (error?.response?.data?.message) {
                toast.error(error?.response?.data?.message);
            }
            setIsDemoFormLoading(false);
        }
    }

    const handleLiveAccount = async (values) => {
        try {
            setIsLiveFormLoading(true);
            let params = {
                balanceDeposit: 0,
                tradingAccountType: 0,
                planId: selectedAccount?.planId,
                userId: userDetails?.id
            }
            const { data } = await CreateAccountTypeApi(params);
            if (data?.success) {
                setIsLiveFormLoading(false);
                toast?.success(data?.message);
                navigate('/accounts?filter=Live+Account');
            }
        } catch (error) {
            if (error?.response?.data?.message) {
                toast.error(error?.response?.data?.message);
            }
            setIsLiveFormLoading(false);
        }
    }

    const goToDashboard = () => {
        setIsOpenDemoAccountSuccess(false);
        navigate('/dashboard');
    }

    useEffect(() => {
        form.resetFields();
    }, [isOpenDemoForm, isOpenLiveForm]);

    return (
        <div>
            <div className='border rounded p-4 lg:p-6'>
                {isLoading ? (
                    <div className="flex justify-center flex-col my-[20%]">
                        <Spin size="large" />
                        <p className="primary text-center mt-2">Loading...</p>
                    </div>
                ) : (
                    <div className='flex flex-wrap justify-center items-center gap-8 mx-auto' >
                        {
                            accountTypes?.map((account, index) => (
                                <WhiteCard key={index} account={account} handleSubmit={createAccount} type={searchParams?.get('type')} />
                            ))
                        }
                    </div>
                )}
            </div>

            {/* Open demo account form modal */}
            <ModalComponent isOpen={isOpenDemoForm} setIsOpen={setIsOpenDemoForm} title='Open Demo Account'>
                <Form className='w-full' autoComplete="off" form={form} initialValues={demoInitialValues} onFinish={handleDemoAccount}>
                    <div className='ant-select-selector-white'>
                        <label className='text-base text-[#2F2B3DCC] font-medium'>Deposit</label>
                        <Form.Item name='depositAmount' rules={[{ required: true, message: 'Please select deposit.' }]}>
                            <Select className='border-primary w-full mt-1' placeholder='Select deposit' options={depositOptions} />
                        </Form.Item>
                    </div>
                  
                    <div className='flex justify-center items-center gap-5 mt-10'>
                        <LoadableButton
                            className='bg-primary text-sm text-white font-semibold rounded-lg px-12 py-2 uppercase themeHover duration-500'
                            disabled={isDemoFormLoading}
                            type="Submit"
                            lable='Proceed'
                            isLoading={isDemoFormLoading}
                            loadingLable='Opening Demo Account...'
                        />
                        <button type='button' disabled={isDemoFormLoading} className='bg-red-500 text-sm text-white font-medium uppercase px-8 py-2 rounded-lg hover:bg-red-600 duration-500' onClick={() => setIsOpenDemoForm(false)}>Cancel</button>
                    </div>
                </Form>
            </ModalComponent>

            {/* Demo account success modal */}
            <ModalComponent isOpen={isOpenDemoAccountSuccess} setIsOpen={setIsOpenDemoAccountSuccess} title='Congratulations!, Demo Account Created!'>
                <p className='primary md:text-lg font-semibold'>{userDetails?.fullName} you have Successfully Open Vertex Account.</p>
                <div>
                    <div className='flex justify-between items-center mt-8 border-y py-2 px-4'>
                        <div className='flex items-center'><img src='/assets/icons/checkmark-green.svg' width={22} alt='icon' /><p className='text-sm sm:text-lg font-medium text-[#413079] ml-3'>Account No.</p></div>
                        <div className='flex justify-center items-center'>
                            <p className='text-sm sm:text-lg font-medium text-[#413079] mr-2'>{createdDemoAccount?.terminalID}</p>
                            <Copy text={createdDemoAccount?.terminalID}></Copy>
                        </div>
                    </div>
                    <div className='flex justify-between items-center mt-2 border-b pb-2 px-4'>
                        <div className='flex items-center'><img src='/assets/icons/checkmark-green.svg' width={22} alt='icon' /><p className='text-sm sm:text-lg font-medium text-[#413079] ml-3'>Environment Name</p></div>
                        <p className='text-sm sm:text-lg font-medium text-[#413079] mr-2'>{createdDemoAccount?.environmentName}</p>
                    </div>
                    {/* <div className='flex justify-between items-center mt-2 border-b pb-2 px-4'>
                        <div className='flex items-center'><img src='/assets/icons/checkmark-green.svg' width={22} alt='icon' /><p className='text-sm sm:text-lg font-medium text-[#413079] ml-3'>Master Password</p></div>
                        <div className='flex justify-center items-center'>
                            <p className='text-sm sm:text-lg font-medium text-[#413079] mr-2'>{createdDemoAccount?.password}</p>
                            <Copy text={createdDemoAccount?.password}></Copy>
                        </div>
                    </div> */}
                    <div className='flex justify-between items-center mt-2 border-b pb-2 px-4'>
                        <div className='flex items-center'><img src='/assets/icons/checkmark-green.svg' width={22} alt='icon' /><p className='text-sm sm:text-lg font-medium text-[#413079] ml-3'>Investor Password</p></div>
                        <div className='flex justify-center items-center'>
                            <p className='text-sm sm:text-lg font-medium text-[#413079] mr-2'>{createdDemoAccount?.investorPassword}</p>
                            <Copy text={createdDemoAccount?.investorPassword}></Copy>
                        </div>
                    </div>
                </div>
                <div className='mt-8 flex justify-center items-center'>
                    <button className='bg-primary text-sm text-white font-semibold px-6 py-2 rounded-lg themeHover duration-500' onClick={goToDashboard}>Go To Dashboard</button>
                </div>
            </ModalComponent >

            <ConfirmationModal
                isOpen={isOpenLiveForm}
                setIsOpen={setIsOpenLiveForm}
                message=" Are you sure you want to open live account?"
                onConfirm={handleLiveAccount}
                isLoading={isLiveFormLoading}
                loadingLabel='Open live account...'
            />

          
        </div >
    )
}